export default __webpack_public_path__ + "482488905c95025df1d2cc923de07a42.png";